import { redirect } from "react-router-dom"
import {API} from "../../backend"
import { useMsal } from "@azure/msal-react"


export const register = user => {
    console.log(user)
    return fetch(`${API}/register`,{
        method: "POST",
        headers: {
            Accept: "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify(user)
    })
    .then(response => {
        return response.json()
    })
    .catch(err => console.log(err))
}


export const login = user => {
    return fetch(`${API}/login`,{
        method: "POST",
        headers: {
            Accept: "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify(user)
    })
    .then(response => {
        return response.json()
    })
    .catch(err => console.log(err))
}


export const authenticate = (data,next) => {
    if(typeof window !== undefined){
        localStorage.setItem("jwt",JSON.stringify(data))
        next()
    }
}

export const logout = (next) => {
    if(typeof window !== undefined){
        localStorage.removeItem("jwt")
        next()
         return fetch(`${API}/logout`,{
            method:"GET"
        })
        .then((response) => {
            return redirect("/login")
    })
        .catch((err) => {
            console.log(err)
            return redirect("/login")
    })
    }
}

export const mslogout = () => {
    if(typeof window !== undefined){
        localStorage.removeItem("jwt")
         return fetch(`${API}/logout`,{
            method:"GET"
        })
        .then((response) => {
            return redirect("/login")
    })
        .catch((err) => {
            console.log(err)
            return redirect("/login")
    })
    }
}

export const isAuthenticated = () => {
    if(typeof window == undefined){
       return false
    }
    if(localStorage.getItem("jwt")){
        return JSON.parse(localStorage.getItem("jwt"))
    }else{
        return false
    }
}

export const forgotPassword = (email) => {
  return fetch(`${API}/forgotPassword`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
    }),
  })
    .then(async (response) => {
      const data = await response.json();

      if (!response.ok) {
        return {
          error:
            data.error ||
            "Unable to send the password reset email.",
        };
      }

      return data;
    })
    .catch((error) => {
      console.error("Forgot password API error:", error);

      return {
        error:
          "Unable to connect to the server. Please try again.",
      };
    });
};

export const verifyResetPasswordToken = (resetToken) => {
  return fetch(
    `${API}/resetPassword/${encodeURIComponent(resetToken)}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  )
    .then(async (response) => {
      const data = await response.json();

      if (!response.ok) {
        return {
          error:
            data.error ||
            "The password reset link is invalid or expired.",
        };
      }

      return data;
    })
    .catch((error) => {
      console.error("Verify reset token API error:", error);

      return {
        error:
          "Unable to verify the password reset link.",
      };
    });
};

export const resetPassword = (
  resetToken,
  password,
  retypepassword
) => {
  return fetch(
    `${API}/resetPassword/${encodeURIComponent(resetToken)}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        password,
        retypepassword,
      }),
    }
  )
    .then(async (response) => {
      const data = await response.json();

      if (!response.ok) {
        return {
          error:
            data.error || "Unable to reset the password.",
        };
      }

      return data;
    })
    .catch((error) => {
      console.error("Reset password API error:", error);

      return {
        error:
          "Unable to connect to the server. Please try again.",
      };
    });
};